const configData =  {
    baseURL: 'https://app.aplikovanainformatika.sk',
    client_secret: "iQuGUAzqc187j7IKQ94tTVJAywHCAzYBGAMTxEtr"
}

export default configData